export default {
  state: {
    detail: null,
    urlQuery: null,
    registrationList: null
    // registrationListIndex: 0
  },
  mutations: {
    setVendorRegistDetail(state, payload) {
      state.detail = payload
    },
    setVendorRegistQuery(state, payload) {
      state.urlQuery = payload
    },
    setVendorRegistrationList(state, payload) {
      state.registrationList = payload.list
      // state.registrationListIndex = payload.index
    }
  },
  actions: {},
  getters: {
    getVendorRegistDetail(state) {
      return state.detail
    },
    getVendorRegistQuery(state) {
      return state.urlQuery
    },
    getVendorRegistList(state) {
      return {
        registrationList: state.registrationList
      }
    }
  }
}
